"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = void 0;

var _createFirebaseInstance = _interopRequireWildcard(require("./createFirebaseInstance")),
    _ReactReduxFirebaseProvider = _interopRequireDefault(require("./ReactReduxFirebaseProvider")),
    _ReactReduxFirebaseContext = _interopRequireDefault(require("./ReactReduxFirebaseContext")),
    _ReduxFirestoreProvider = _interopRequireDefault(require("./ReduxFirestoreProvider")),
    _ReduxFirestoreContext = _interopRequireDefault(require("./ReduxFirestoreContext")),
    _firebaseConnect = _interopRequireDefault(require("./firebaseConnect")),
    _firestoreConnect = _interopRequireDefault(require("./firestoreConnect")),
    _withFirebase = _interopRequireDefault(require("./withFirebase")),
    _withFirestore = _interopRequireDefault(require("./withFirestore")),
    _useFirebaseConnect = _interopRequireDefault(require("./useFirebaseConnect")),
    _useFirestoreConnect = _interopRequireDefault(require("./useFirestoreConnect")),
    _useFirebase = _interopRequireDefault(require("./useFirebase")),
    _useFirestore = _interopRequireDefault(require("./useFirestore")),
    _reducer = _interopRequireDefault(require("./reducer")),
    _constants = _interopRequireWildcard(require("./constants")),
    _auth = require("./utils/auth"),
    helpers = _interopRequireWildcard(require("./helpers"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if ("function" != typeof WeakMap) return null;
  var cache = new WeakMap();
  return _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  }, cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) return obj;
  if (null === obj || "object" !== _typeof(obj) && "function" != typeof obj) return {
    default: obj
  };

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) return cache.get(obj);
  var newObj = {},
      hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      desc && (desc.get || desc.set) ? Object.defineProperty(newObj, key, desc) : newObj[key] = obj[key];
    }
  }

  return newObj.default = obj, cache && cache.set(obj, newObj), newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var source, i = 1; i < arguments.length; i++) {
    source = null == arguments[i] ? {} : arguments[i], i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  return key in obj ? Object.defineProperty(obj, key, {
    value: value,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : obj[key] = value, obj;
}

var _default = _objectSpread({
  ReactReduxFirebaseProvider: _ReactReduxFirebaseProvider.default,
  ReactReduxFirebaseContext: _ReactReduxFirebaseContext.default,
  ReduxFirestoreContext: _ReduxFirestoreContext.default,
  ReduxFirestoreProvider: _ReduxFirestoreProvider.default,
  createFirebaseInstance: _createFirebaseInstance.default,
  firebaseConnect: _firebaseConnect.default,
  firestoreConnect: _firestoreConnect.default,
  withFirebase: _withFirebase.default,
  withFirestore: _withFirestore.default,
  useFirebase: _useFirebase.default,
  useFirebaseConnect: _useFirebaseConnect.default,
  useFirestore: _useFirestore.default,
  useFirestoreConnect: _useFirestoreConnect.default,
  reducer: _reducer.default,
  firebaseReducer: _reducer.default,
  constants: _constants.default,
  actionTypes: _constants.actionTypes,
  getFirebase: _createFirebaseInstance.getFirebase,
  authIsReady: _auth.authIsReady
}, helpers);

exports.default = _default, module.exports = exports.default;